import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useNavigate, Outlet } from 'react-router-dom'
import { isTrialExpired } from '@disco/utils/trial'
import DocumentHeadTags from 'components/document-head-tags'
import PricingModal from 'components/modals/pricing'

const mapStateToProps = state => ({
  user: state.user,
})

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const ConnectedPricingPage = connector(PricingPage)

function PricingPage({ user }: PropsFromRedux) {
  const navigate = useNavigate()

  const _onClose = () => navigate('/')

  const closeEnabled =
    !user.business.private_metadata.expired_subscription &&
    !isTrialExpired(user)

  return (
    <div>
      <DocumentHeadTags title="Pricing | DISCO" />
      <PricingModal
        onClose={closeEnabled ? _onClose : undefined}
        showBillingSummary
      />
      <Outlet />
    </div>
  )
}

export default ConnectedPricingPage
